//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { LightGallery } from "vue-light-gallery";
export default {
  props: ["thumb", "large", "className"],
  components: {
    LightGallery: LightGallery
  },
  data: function data() {
    return {
      photoIndex: null
    };
  },
  methods: {
    onThumbClick: function onThumbClick(index) {
      this.photoIndex = index;
    },
    handleHide: function handleHide() {
      this.photoIndex = null;
    }
  }
};